import { Switch, Route } from 'react-router-dom';
import React from 'react';

import BasicNewCollection from './new/basic';
import Detail from './detail';
import NewChildJournal from '../child-journals/new';
import NewCustom from '../custom/new';
import NewMemoir from '../memoirs/new';
import TagPicker from './new/tags/picker';
import NewPersonalJournal from './personal-journals/new';
// import NewStoryChat from 'stories/chats/new-story-chat';
// import NewStoryCover from 'stories/new/cover';
// import NewStoryPages from 'stories/new/pages';
// import SelectCollection from 'stories/new/select-collection/index';
import NewStoryRequest from './detail/story-requests/new/new-story-request';

import NotificationSettings from 'members/profile/notification-settings';
import GlobalNewStory from 'stories/new/global/index';
import WatchMeGrowForm from './watch-me-grow/index';
import CollagePreview from './watch-me-grow/collagePreview';
import WatchMeGrowVideoPreview from './watch-me-grow/VideoPreview';
import Milestones from './milestones/index';
import GrowthChart from './growth-chart/index';
import BookCreationForm from './book-creation/index';
import FamilyTree from '../family-tree/index';

const Memoirs = () => {
  return (
    <Switch>
      <Route path="/:type/new/:id/tags" component={TagPicker} />
      <Route component={NewChildJournal} path="/child-journals/new" />
      <Route component={NewMemoir} path="/memoirs/new" />
      <Route component={NewCustom} path="/custom/new" />
      <Route component={NewPersonalJournal} path="/personal-journals/new" />
      <Route
        path="/family-journals/new"
        render={() => <BasicNewCollection titleAttr="name" placeholder="E.g. The Smith Family" />}
      />
      <Route
        path="/personal-journals/new"
        render={() => <BasicNewCollection titleAttr="name" placeholder="E.g. My Memoir" />}
      />
      <Route component={BasicNewCollection} path="/:type/new" />


      {/* <Route path="/:type/:id/stories/new/:story-id/chats/:meetingId" component={NewStoryChat} />
      <Route path="/:type/:id/chapters/:chapter_id/stories/new/:story-id/chats/:meetingId" component={NewStoryChat} />

      <Route path="/:type/:id/stories/new/:story-id/collection" component={SelectCollection} />
      <Route path="/:type/:id/chapters/:chapter_id/stories/new/:story-id/collection" component={SelectCollection} />

      <Route path="/:type/:id/stories/new/:story-id/cover" component={NewStoryCover} />
      <Route path="/:type/:id/chapters/:chapter_id/stories/new/:story-id/cover" component={NewStoryCover} />

      <Route path="/:type/:id/stories/new/:story-id" component={NewStoryPages} />
      <Route path="/:type/:id/chapters/:chapter_id/stories/new/:story-id" component={NewStoryPages} /> */}
      <Route path="/:type/:id/milestones" component={Milestones} />
      <Route path="/:type/:id/growth-chart" component={GrowthChart} />
      <Route path="/:type/:id/family-tree" component={FamilyTree} />
      <Route path="/:type/:id/story-request" component={NewStoryRequest} />
      <Route path="/:type/:id/watch-me-grow" component={WatchMeGrowForm} />
      <Route path="/:type/:id/book-creation" component={BookCreationForm} />

      <Route path="/:type/:id/collage-preview" component={CollagePreview} />
      <Route path="/:type/:id/video-preview" component={WatchMeGrowVideoPreview} />

      <Route component={Detail} path="/:type/:id/chapters/:chapter_id" />

      <Route path="/:type/:id/reminders" component={NotificationSettings} />
      <Route component={GlobalNewStory} path="/:type/:id/lets-begin" />
      <Route component={Detail} path="/:type/:id" />

    </Switch>
  );
};

export default Memoirs;
